var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgProfile = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.70312 12.1406C5.54688 11.3906 7.3125 11.0156 9 11.0156C10.6875 11.0156 12.4375 11.3906 14.25 12.1406C16.0938 12.8594 17.0156 13.8125 17.0156 15V17.0156H0.984375V15C0.984375 13.8125 1.89062 12.8594 3.70312 12.1406ZM11.8125 7.82812C11.0312 8.60938 10.0938 9 9 9C7.90625 9 6.96875 8.60938 6.1875 7.82812C5.40625 7.04688 5.01562 6.10938 5.01562 5.01562C5.01562 3.92188 5.40625 2.98438 6.1875 2.20312C6.96875 1.39062 7.90625 0.984375 9 0.984375C10.0938 0.984375 11.0312 1.39062 11.8125 2.20312C12.5938 2.98438 12.9844 3.92188 12.9844 5.01562C12.9844 6.10938 12.5938 7.04688 11.8125 7.82812Z",
    fill: "black",
    fillOpacity: 0.54
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProfile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/profile.ab7bc7d1.svg";
export { ForwardRef as ReactComponent };